<template>
  <!-- Slider main container -->
  <div class="swiper" ref="slider">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      <div v-for="(image, index) in images" :key="index" class="swiper-slide">
        <img class="swiper-image swiper-lazy" :data-src="image">
        <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
      </div>
    </div>

    <!-- If we need navigation buttons -->
    <div v-if="images.length > 1" class="swiper-button-prev" @click="prev"></div>
    <div v-if="images.length > 1" class="swiper-button-next" @click="next"></div>

    <!-- Contatore immagini -->
    <div class="contatore-immagini">
      <i class="fas fa-camera-retro"></i> {{ images.length }}
    </div>
  </div>
</template>

<script>
import Swiper, { Lazy } from 'swiper';
import 'swiper/swiper-bundle.min.css';

export default {
  props: ['images', 'immobile', 'clickable'],
  data () {
    return {
      swiper: null,
    }
  },
  mounted () {
    this.swiper = new Swiper(this.$refs.slider, {
      // Optional parameters
      modules: [Lazy],
      loop: (this.images.length > 1),
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      preloadImages: false,
      on: {
        doubleClick: this.goToImmobile
      }
    });
  },
  methods: {
    prev () {
      this.swiper.slidePrev();
    },
    next () {
      this.swiper.slideNext();
    },
    goToImmobile () {
      if (this.clickable) {
        window.location.href = '/immobile/' + this.immobile.slug
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-button-prev,
.swiper-button-next {
  color: #ffffff;
  text-shadow: 1px 1px 1px black;
}

.contatore-immagini {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #ffffff;
  z-index: 10;
  text-shadow: 1px 1px 1px black;
}

.pointer {
  cursor: pointer;
}

.swiper {
  &-image {
    height: 300px;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
}</style>